import { DifficultyModel } from './DifficultyModel';
import { PriorityModel } from './PriorityModel';
import { StatusModel } from './StatusModel';
import { TagModel } from './TagModel';
import { TypeModel } from './TypeModel';
import { UserModel } from './UserModel';

/**
 * * Модель основных списоков для задачи
 */
export class TaskDictionariesModel {
  /**Список статусов */
  Statuses: Array<StatusModel> = [];
  /**Список приоритетов */
  Priorities: Array<PriorityModel> = [];
  /**Список типов */
  Types: Array<TypeModel> = [];
  /**Список уровней сложности */
  Difficulties: Array<DifficultyModel> = [];
  /**Список тегов */
  Tags: Array<TagModel> = [];
  /**Список пользователей */
  Users: Array<UserModel> = [];

  /**Дефолтный статус */
  get DefaultStatus() {
    return (
      this.Statuses.find((status) => status.IsDefault) ??
      (this.Statuses.length ? this.Statuses[0] : undefined)
    );
  }
  /**Дефолтный приоритет */
  get DefaultPriority() {
    return (
      this.Priorities.find((priority) => priority.IsDefault) ??
      (this.Priorities.length ? this.Priorities[0] : undefined)
    );
  }
  /**Дефолтная сложность */
  get DefaultDifficulty() {
    return (
      this.Difficulties.find((difficulty) => difficulty.IsDefault) ??
      (this.Difficulties.length ? this.Difficulties[0] : undefined)
    );
  }

  /**Дефолтный тип */
  get DefaultType() {
    return (
      this.Types.find((type) => type.IsDefault) ?? (this.Types.length ? this.Types[0] : undefined)
    );
  }
  /**Списки пусты */
  get IsEmpty() {
    return (
      !this.Statuses.length &&
      !this.Priorities.length &&
      !this.Types.length &&
      !this.Difficulties.length &&
      !this.Tags.length &&
      !this.Users.length
    );
  }

  constructor(obj?: Partial<TaskDictionariesModel>) {
    Object.assign(this, obj);
  }
}
